"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var data = {
  mainRoutes: [{
    label: "MY BOX",
    route: "/my-box",
    id: "my_box",
    authReq: true,
    hideByPlans: ["access_trial", "access_annual"],
    subRoutes: [{
      label: "View Box",
      route: "/my-box/",
      id: "view_box",
      authReq: true
    }, // {
    //   label: "Add-Ons",
    //   route: "/add-ons/",
    //   id: "add_ons",
    //   authReq: true
    // },
    {
      label: "Customize",
      route: "/customize/",
      id: "customize",
      authReq: true
    }]
  }, {
    label: "SHOP",
    route: "/shop/",
    id: "shop"
  }, {
    label: "TV",
    route: " ",
    subdomain: "tv",
    id: "tv"
  }, {
    label: "OFFERS",
    id: "offers",
    subRoutes: [{
      label: "Exclusive Offers",
      route: "/exclusive-offers/",
      id: "exclusive_offers"
    }, {
      label: "Giveaways",
      route: "/giveaway/",
      id: "giveaway"
    }]
  }, {
    label: "GIFT",
    route: "/gift/",
    id: "gift"
  }, {
    label: "MAGAZINE",
    route: "/magazine",
    id: "magazine"
  }, {
    label: "COMMUNITY",
    route: " ",
    subdomain: "talk",
    id: "community"
  }, {
    label: "MY ACCOUNT",
    id: "my_account",
    authReq: true,
    subRoutes: [{
      label: "My Account",
      route: "/my-account/",
      id: "my_account"
    }, {
      label: "My Subscription & Orders",
      route: "/my-account/#!orders",
      id: "account_orders"
    }, {
      label: "Refer A Friend, Earn $15",
      route: "/invite/",
      id: "invite"
    }, {
      label: "Personal Profile",
      route: "/my-account/#!survey",
      id: "account_survey"
    }, {
      label: "Manage Email Preferences",
      route: "/manage-email-preferences/",
      id: "email-preferences"
    }, {
      label: "Log Out",
      route: "/my-account/?customer-logout=true",
      id: "account_logout"
    }]
  }],
  notice: {
    links: [{
      id: "events",
      label: "Events Calendar",
      route: "/events/"
    }, {
      id: "community",
      label: "Community Photos (Beta)",
      route: "/community-photos/"
    }]
  }
};
exports.default = data;